import { useRef, useEffect } from 'react';
import { Button } from '../components/Button.jsx';
import { PAGE } from '../state/pages.js';

const PLAYER_ID_MIN_LENGTH = 3;
const PLAYER_ID_MAX_LENGTH = 6;

export function NameEntryPage({ playerName, onNameChange, onNavigate }) {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  function handleInput(e) {
    const value = e.target.value
      .toUpperCase()
      .replace(/\s/g, '');
    onNameChange(value);
  }

  function handleContinue() {
    if (isValid) {
      onNavigate(PAGE.SETUP_COUNTRY);
    }
  }

  function handleBack() {
    onNavigate(PAGE.HOME);
  }

  const isValid =
    playerName.length >= PLAYER_ID_MIN_LENGTH &&
    playerName.length <= PLAYER_ID_MAX_LENGTH &&
    !/\s/.test(playerName);

  return (
    <main tabIndex={-1} className="onboarding-screen onboarding-name">
      <div className="onboarding-content">
        <h1 className="onboarding-title">Enter your planner ID</h1>

        <div className="onboarding-form">
          <input
            ref={inputRef}
            type="text"
            value={playerName}
            onChange={handleInput}
            maxLength={PLAYER_ID_MAX_LENGTH}
            placeholder="AL!C&E"
            className="onboarding-input onboarding-input-large"
            aria-label="3 to 6 character planner ID"
            autoComplete="off"
          />
          <p className="onboarding-hint">
            Use 3 to 6 visible characters. {playerName.length} of {PLAYER_ID_MAX_LENGTH}.
          </p>
        </div>

        <div className="onboarding-actions">
          <Button
            variant="ghost"
            onClick={handleBack}
            changesScreen
            testId="name-back"
            audioCue="buttonSecondary"
          >
            Back
          </Button>
          <Button
            onClick={handleContinue}
            changesScreen
            disabled={!isValid}
            testId="name-continue"
            audioCue="buttonSecondary"
          >
            Continue
          </Button>
        </div>
      </div>
    </main>
  );
}
